import _regeneratorRuntime from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import Marker from './view/marker';
import { ErrorHandler } from './helpers/ErrorHandler';
import DocumentBuilder from './DocumentBuilder';
import { GUID } from './helpers/randomID';
/**
 * @typedef {Object} Core
 * @property {Object} documentBuilder the builder of the documents
 * @property {Document[]} _documents the list of the documents in the session
 * @property {number[]} _documentsIds The index ids of the documents
 * @property {number} actualSessionIndex the index id of the actual document
 *
 */

var Crate =
/*#__PURE__*/
function () {
  function Crate() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var documentBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, Crate);

    if (!documentBuilder) {
      documentBuilder = DocumentBuilder;
    }

    this.documentBuilder = new documentBuilder(options, this); // key=index,value=session

    this._documents = []; // key=sessionId,value=documentIndex

    this._documentsIds = new Map();
    this.actualSessionIndex = -1; // Documents that are started creating them, this is to avoid to create twice the same document

    this._documentsWaiting = new Set();
  }
  /**
   * Get all document indexes
   */


  _createClass(Crate, [{
    key: "getDocumentIndexs",
    value: function getDocumentIndexs() {
      var keys = Array.from(this._documents.keys());
      return keys;
    }
    /**
     * Get document by its index
     * @param {*} index  it is index in the core
     * @deprecated
     */

  }, {
    key: "getDocument",
    value: function getDocument(index) {
      return this._documents[index];
    }
    /**
     * Get document by its index
     * @param {*} index  it is index in the core
     */

  }, {
    key: "getDocumentByIndex",
    value: function getDocumentByIndex(index) {
      return this._documents[index];
    }
    /**
     * Get document by its document Id
     * @param {string} documentId  it is index in the core
     */

  }, {
    key: "getDocumentByDocumentId",
    value: function getDocumentByDocumentId(documentId) {
      var index = this.getIndexFromDocumentId(documentId);
      return this._documents[index];
    }
  }, {
    key: "getNumberOfDocuments",
    value: function getNumberOfDocuments() {
      return this._documents.length;
    }
    /**
     * Create a new document ans set it as actual document
     * @param {string} documentId the id of the document
     * @param {Object} specialOpts special options that override the default options
     * @returns {void|Core}
     */

  }, {
    key: "createNewDocument",
    value: function () {
      var _createNewDocument = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(documentId) {
        var specialOpts,
            searchIndex,
            waitingCreation,
            documentIndex,
            doc,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                specialOpts = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                searchIndex = this.getIndexFromDocumentId(documentId);
                waitingCreation = this._documentsWaiting.has(documentId);

                if (!(!searchIndex && searchIndex != 0 && !waitingCreation)) {
                  _context.next = 29;
                  break;
                }

                this._documentsWaiting.add(documentId);

                documentIndex = this.getNumberOfDocuments();
                doc = null;
                _context.prev = 7;
                _context.next = 10;
                return this.documentBuilder.buildDocument(documentId, documentIndex, null, specialOpts);

              case 10:
                doc = _context.sent;
                this.addDocument(doc);

                this._documentsIds.set(documentId, documentIndex);

                _context.next = 15;
                return doc.initView();

              case 15:
                this._documentsWaiting.delete(documentId);

                this.setActualDocument(documentId);
                _context.next = 19;
                return doc.init();

              case 19:
                _context.next = 26;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context["catch"](7);

                this._documentsWaiting.delete(documentId);

                if (this.exist(documentIndex)) this.removeDocument(documentIndex);
                console.error('problem in the creation of the document', _context.t0);

              case 26:
                return _context.abrupt("return", doc);

              case 29:
                if (waitingCreation) {
                  _context.next = 34;
                  break;
                }

                this.setActualDocument(documentId);
                return _context.abrupt("return", this.getDocumentByDocumentId(documentId));

              case 34:
                console.warn('The document is under creation');
                return _context.abrupt("return", null);

              case 36:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 21]]);
      }));

      return function createNewDocument(_x) {
        return _createNewDocument.apply(this, arguments);
      };
    }()
    /**
     * add document to list of documents
     * @param {Document} document
     */

  }, {
    key: "addDocument",
    value: function addDocument(document) {
      this._documents.push(document);

      this.updateView();
    }
    /**
     *  remove document and update the status of the different documents
     * @param {number} documentIndex
     */

  }, {
    key: "removeDocument",
    value: function removeDocument(documentIndex) {
      var _this = this;

      if (this.exist(documentIndex)) {
        //Change the index off all the documentIndexs that are greater than documentIndex
        this.getDocumentIndexs().filter(function (index) {
          return index > documentIndex;
        }).map(function (index) {
          return _this.getDocument(index);
        }).map(function (document) {
          _this._documentsIds.set(_this.getDocumentIdFromIndex(document.documentIndex), document.documentIndex - 1);

          document.documentIndex -= 1;
        });
        var documentId = this.getDocumentIdFromIndex(documentIndex);

        this._documentsIds.delete(documentId); //change the new index in  the session


        this._documents.splice(documentIndex, 1);

        this.updateActualDocumentIndex(documentIndex);
        this.updateView();
      } else {
        throw new ErrorHandler().SESSION_NOT_FOUND(documentIndex);
      }
    }
    /**
     * Update the actual document index after removing a document
     * @param {number} removedIndex
     */

  }, {
    key: "updateActualDocumentIndex",
    value: function updateActualDocumentIndex(removedIndex) {
      // if we remove the selected document move to previous if exist, else move to next if exist, else set  actualSessionIndex = -1
      if (this.actualSessionIndex === removedIndex) {
        if (this.exist(removedIndex - 1)) {
          this.setActualDocument(this.getDocumentIdFromIndex(removedIndex - 1));
        } else if (this.exist(removedIndex + 1)) {
          this.setActualDocument(this.getDocumentIdFromIndex(removedIndex + 1));
        } else {
          this.actualSessionIndex = -1;
        }
      } else if (this.actualSessionIndex > removedIndex) {
        this.actualSessionIndex--;
      }
    }
    /**
     * Emit FocusIn event to the document with documentIndex index
     * @param {number} documentIndex
     */

  }, {
    key: "focusInToDocument",
    value: function focusInToDocument(documentIndex) {
      if (this.exist(documentIndex)) {
        this.getDocument(documentIndex).emit('FocusIn');
      } else {
        throw new ErrorHandler().SESSION_NOT_FOUND(documentIndex);
      }
    }
    /**
     * Emit FocusOut event to the document with documentIndex index
     * @param {number} documentIndex
     */

  }, {
    key: "focusOutToDocument",
    value: function focusOutToDocument(documentIndex) {
      if (this.exist(documentIndex)) {
        this.getDocument(documentIndex).emit('FocusOut');
      } else {
        throw ErrorHandler().SESSION_NOT_FOUND(documentIndex);
      }
    }
    /**
     * get Document Index from document Id
     * @param {string} documentId
     * @returns {number} documentIndex
     */

  }, {
    key: "getIndexFromDocumentId",
    value: function getIndexFromDocumentId(documentId) {
      return this._documentsIds.get(documentId);
    }
    /**
     * get Document Id from document Index
     * @param {number} documentIndex
     * @returns {string} documentId
     */

  }, {
    key: "getDocumentIdFromIndex",
    value: function getDocumentIdFromIndex(documentIndex) {
      return this.getDocument(documentIndex).documentId;
    }
    /**
     * Set actual document by document Id. The actual document is the document that w're editing
     * @param {string} documentId
     */

  }, {
    key: "setActualDocument",
    value: function setActualDocument(documentId) {
      var _this2 = this;

      var documentIndex = this.getIndexFromDocumentId(documentId);

      if (documentIndex === undefined) {
        throw Error('Document ' + documentId + ' dose not exist');
      } else if (this.actualSessionIndex != documentIndex) {
        this.actualSessionIndex = documentIndex;
        this.focusInToDocument(documentIndex); //emit FocusOut to all other sessions

        this.getDocumentIndexs().filter(function (index) {
          return index != documentIndex;
        }).forEach(function (documentIndex) {
          return _this2.focusOutToDocument(documentIndex);
        });
      }
    }
    /**
     * get actual document index
     * @returns {Document}
     *    */

  }, {
    key: "getActualDocument",
    value: function getActualDocument() {
      return this.getDocument(this.actualSessionIndex);
    }
    /**
     * Emit 'UpdateView' to all the documents
     */

  }, {
    key: "updateView",
    value: function updateView() {
      var _this3 = this;

      this.getDocumentIndexs().forEach(function (documentIndex) {
        _this3.getDocument(documentIndex).emit('UpdateView', _this3.getNumberOfDocuments());
      });
    }
    /**
     * Focus on the next document (it dose exist)
     */

  }, {
    key: "moveToNext",
    value: function moveToNext() {
      return this.moveTo(this.actualSessionIndex + 1);
    }
    /**
     * Focus on the Previous document (it dose exist)
     */

  }, {
    key: "moveToPrevious",
    value: function moveToPrevious() {
      return this.moveTo(this.actualSessionIndex - 1);
    }
    /**
     * Move to a given document index
     * @param {number} documentIndex
     * @returns {Core} document
     */

  }, {
    key: "moveTo",
    value: function moveTo(documentIndex) {
      if (this.exist(documentIndex)) {
        this.setActualDocument(this.getDocumentIdFromIndex(documentIndex));
      }

      return this;
    }
    /**
     * Dose the given documment index exist in the list of documents
     * @param {number} documentIndex
     */

  }, {
    key: "exist",
    value: function exist(documentIndex) {
      return this.getDocument(documentIndex) !== undefined;
    }
    /**
     * Dose the given documment index exist in the list of documents
     * @param {number} documentIndex
     */

  }, {
    key: "exist",
    value: function exist(documentIndex) {
      return this.getDocument(documentIndex) !== undefined;
    }
    /**
     * Get random Id, this used for documents and for users
     * @returns {string} random Id
     */

  }], [{
    key: "getRandomId",
    value: function getRandomId() {
      return GUID();
    }
  }]);

  return Crate;
}();

export { Crate as default };
Crate.Marker = Marker;